module.exports = __webpack_public_path__ + "img/icon_check_white.8e4966e5.svg";